/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react'
import './index.scss'
// import { makeStyles } from '@material-ui/core/styles'
// import MenuItem from '@material-ui/core/MenuItem'
// import FormControl from '@material-ui/core/FormControl'
// import Select from '@material-ui/core/Select'
// import axios from 'axios'
import { connect } from 'react-redux'
import IconClear from './IconClear'
import setAccountIdParam from './actions'
import setSearchString from '../UserSearch/actions'

// const useStyles = makeStyles(theme => ({
//     formControl: {
//         margin: theme.spacing(1),
//         minWidth: 120,
//     },
//     selectEmpty: {
//         marginTop: theme.spacing(2),
//     },
// }))

const AccountSelector = ({
    accountIdParam,
    setAccountIdParam,
    setSearchString,
}) => {
    // const classes = useStyles()
    const [accountId, setAccountId] = useState('')
    // const [accountIds, setAccountIds] = useState([])

    // useEffect(() => {
    //     return
    //     const authorization = localStorage.getItem(
    //         'pulsarBotPlatform_operatorToken'
    //     )
    //     axios({
    //         method: 'GET',
    //         url: '/api/threads/accountIds',
    //         headers: { authorization },
    //     }).then(res => setAccountIds(res.data))
    // }, [])

    // material ui issue, leave like this
    useEffect(() => {
        if (!accountIdParam) setAccountId('')
    }, [accountIdParam])

    // const handleChange = event => {
    //     setAccountId(event.target.value)
    //     setAccountIdParam(event.target.value)
    // }

    const clear = () => {
        setAccountId('')
        setAccountIdParam('')
        setSearchString('')
    }

    return (
        <div className='AccountSelector'>
            {/* <span>Dealer</span> */}
            {/* <FormControl className={classes.formControl}>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={accountId}
                    onChange={handleChange}
                >
                    {accountIds.map(accountId => (
                        <MenuItem value={accountId}>{accountId}</MenuItem>
                    ))}
                </Select>
            </FormControl> */}
            {accountId && (
                <span onClick={clear}>
                    <IconClear />
                </span>
            )}
        </div>
    )
}

const mapStateToProps = state => ({
    accountIdParam: state.operatorDashboardAccountSelector.accountIdParam,
})

export default connect(mapStateToProps, { setAccountIdParam, setSearchString })(
    AccountSelector
)
